import React, {
    ReactElement, useState,
    useEffect,
} from "react";
import {
    Dropdown,
} from "react-bootstrap";
import { toInputDate, toInputTime } from "../../../date";

export interface DateRangeProps {
    startDate?: Date;
    endDate?: Date;
    className?: string;
    onChange: (startDate: Date | undefined, endDate: Date | undefined) => void;
    onReset?: () => void;
}

const TIMEZONE = new Date().getTimezoneOffset();
const OFFSET = `${TIMEZONE > 0 ? "-" : "+"}${Math.abs(Math.round(TIMEZONE / 60)).toString().padStart(2, "0")
}:${
    Math.abs(Math.round(TIMEZONE % 60)).toString().padStart(2, "0")}`;

export default function DateRangeFilter(props: DateRangeProps): ReactElement {
    const [isDisplayDate, setIsDisplayDate] = useState(false);
    const [startDate, setStartDate] = useState<string | undefined>(props.startDate ? toInputDate(props.startDate) : undefined);
    const [endDate, setEndDate] = useState<string | undefined>(props.endDate ? toInputDate(props.endDate) : undefined);

    useEffect(() => {
        setStartDate(props.startDate ? toInputDate(props.startDate) : "");
        setEndDate(props.endDate ? toInputDate(props.endDate) : "");
    }, [props.startDate, props.endDate]);

    useEffect(() => {
        const fullEndDate = endDate ? `${endDate}T23:59:59` : undefined;
        const inputEndDate = props.endDate ? `${toInputDate(props.endDate)}T${toInputTime(props.endDate)}` : undefined;
        const inputStart = props.startDate ? toInputDate(props.startDate) : undefined;
        if ((startDate && startDate !== inputStart) || (fullEndDate && fullEndDate !== inputEndDate)) {
            props.onChange(
                startDate ? new Date(`${startDate}T00:00:00${OFFSET}`) : undefined,
                fullEndDate ? new Date(fullEndDate + OFFSET) : undefined,
            );
        }
    }, [startDate, endDate]);

    const today = new Date();
    const maxDate = toInputDate(today);

    return (

        <Dropdown
            className="p-0 m-0 text-light"
            show={isDisplayDate}
            onToggle={() => setIsDisplayDate(curr => !curr)}
        >
            <Dropdown.Toggle variant="none" className={props.className}>
                <small>
                    Created
                    {!startDate && !endDate && " Date"}
                    {startDate && !endDate && " after "}
                    {startDate && endDate && " between "}
                    {startDate ? new Date(`${startDate}T00:00:00${OFFSET}`).toLocaleDateString() : ""}
                    {startDate && endDate && " and "}
                    {!startDate && endDate && " before "}
                    {endDate ? new Date(`${endDate}T23:59:59${OFFSET}`).toLocaleDateString() : ""}
                </small>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <form
                    className="p-2 py-1"
                    onSubmit={evt => {
                        evt.preventDefault();
                        setIsDisplayDate(false);
                    }}
                >
                    <h6 className="mb-3">Filter by Created Date</h6>

                    <label className="mb-2 w-100">
                        <span className="mb-1">Start Date</span>
                        <input
                            type="date"
                            className="form-control w-100"
                            value={startDate}
                            onChange={evt => setStartDate(evt.target.value)}
                            max={endDate || maxDate}
                        />
                    </label>

                    <label className="mb-2 w-100">
                        <span className="mb-1">End Date</span>
                        <input
                            type="date"
                            className="form-control w-100"
                            value={endDate}
                            onChange={evt => setEndDate(evt.target.value)}
                            min={startDate}
                            max={maxDate}
                        />
                    </label>

                    <div className="d-flex justify-content-between">
                        <button
                            type="button"
                            className="btn btn-none text-danger btn-sm p-2 mt-2"
                            onClick={() => {
                                if (props.onReset) {
                                    props.onReset();
                                } else {
                                    setStartDate("");
                                    setEndDate("");
                                }

                                setIsDisplayDate(false);
                            }}
                        >
                            Reset
                        </button>

                    </div>
                </form>

            </Dropdown.Menu>
        </Dropdown>

    );
}

DateRangeFilter.defaultProps = {
    startDate: undefined,
    endDate: undefined,
    className: "text-light-400 p-0 me-3",
    onReset: undefined,
};
